import { render, staticRenderFns } from "./SmoothScroll.vue?vue&type=template&id=cf29cdae&scoped=true&"
import script from "./SmoothScroll.vue?vue&type=script&lang=js&"
export * from "./SmoothScroll.vue?vue&type=script&lang=js&"
import style0 from "./SmoothScroll.vue?vue&type=style&index=0&id=cf29cdae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf29cdae",
  null
  
)

export default component.exports